'use strict';

var $ = require('jquery');

var flyinscrolling = {
    /**
     * @function flyinscrolling
     * @description smooth scrolling for fly-in site page menus
     */
    init: function () {
        // get element
        var anchorEl = document.getElementById('fly-in-top-marker'),
            topPos;
        if (
            anchorEl !== undefined &&
            anchorEl !== null &&
            anchorEl.offsetTop !== undefined &&
            anchorEl.offsetTop !== null
        ) {
            // get position
            topPos = anchorEl.offsetTop;
            // set position
            document.getElementById('fly-in-top-marker').scrollTop = topPos;
        }
        // scroll to either default or customized position
        $('#fly-in-back-to-top').click(function () {
            $('.fly-in-dialogue').animate({
                scrollTop: $('#fly-in-top-marker').offset().top
            });
        });
    }
};

module.exports = flyinscrolling;
